<div class="form-layout-3 form-subcontainer">
  <div class="form-content">
    <div>
      <form formName="purchaseOrder" [formGroup]="formGroup" (ngSubmit)="confirm()" class="fpx-form-group">
        <section class="account-sec">
          <app-mutual-fund-list formControlName="accountNumber"
          [disabled]="state.disableMode"></app-mutual-fund-list>
        </section>

        <section class="request-details-sec">
          <div class="details-entry-panel">
            <div class="fpx-field">
              <app-units label="{{'PURCHASEORDER.units'| translate}}" formControlName="noOfUnits" placeholder="{{'PURCHASEORDER.placeholderPurchase'| translate}}"></app-units>
            </div>

            <div class="fpx-field col-12">
              <app-terms-and-condition (emitOpenDocument)="openDocument()" label="{{'PURCHASEORDER.termsCondition'| translate}}"
                formControlName="termsCondition"></app-terms-and-condition>
            </div>


            <div [hidden]="requestReference" class="center-main">
              <ng-container *ngIf="!formGroup.disabled ; else confirmTemplate">

                <section class="from-button-sec">
                  <button class="btn-link" (click)="reset()">
                    <span>{{'FORM_ACTIONS.reset'| translate}}</span>
                  </button>
                </section>

                <section class="from-button-sec">
                  <button type="button" (click)="submit()" class="button-common button40 active"
                    [disabled]="formGroup.invalid">
                    <span>{{'FORM_ACTIONS.submit'| translate}}</span>
                  </button>
                </section>

              </ng-container>

              <ng-template #confirmTemplate>


                <section class="from-button-sec">
                  <button class="btn-link" (click)="edit()">
                    <span>{{'FORM_ACTIONS.edit'| translate}}</span>
                  </button>
                </section>

                <section class="from-button-sec">
                  <button type="submit" class="button-common button40 active" [disabled]="formGroup.invalid">
                    <span>{{'FORM_ACTIONS.confirm'| translate}} </span>
                  </button>
                </section>

              </ng-template>

            </div>
          </div>
        </section>
      </form>
    </div>
  </div>
</div>